/**
 * GxSeatPinNotice: the one-time sight of a CEO/CRO seat PIN (`JoinCodeResponse.seatPin`, ADR-0031). The server keeps only the hash (ADR-0024),
 * so this dialog is the only place the officer can read it; closing it is the acknowledgement. The PIN is what `seatHandoff` takes on a shared laptop.
 */
import { Dialog } from "./Dialog";
import "./seat-pin.css";

export function GxSeatPinNotice({ pin, role, onDone }: { readonly pin: string; readonly role: "ceo" | "cro"; readonly onDone: () => void }) {
  const label = role === "cro" ? "risk officer" : "CEO";
  return (
    <Dialog title="Your seat PIN" testId="join.seatPin" onClose={onDone}
      lead={`Write this down now. You see it once, and we cannot show it again.`}
      footer={<><span className="gx-small gx-muted gx-grow">Keep it to yourself: it is how someone acts as your {label}.</span><button type="button" className="gx-btn gx-btn--primary" onClick={onDone}>I&apos;ve written it down</button></>}>
      <div className="gx-card-b gx-pin">
        <div className="gx-eyebrow">{label} seat PIN</div>
        <div className="gx-pin-digits gx-num" role="img" aria-label={`PIN ${pin.split("").join(" ")}`} data-testid="join.seatPin.digits">
          {pin.split("").map((d, i) => <span key={i} className="gx-pin-digit" aria-hidden="true">{d}</span>)}
        </div>
        <p className="gx-small gx-muted">On a shared laptop, choose &ldquo;Hand to {label}&rdquo; and enter these four digits. The laptop then acts as your {label} seat for 10 minutes and shows who is acting. Five wrong tries lock the seat for a while, longer each time.</p>
      </div>
    </Dialog>
  );
}
